import React from 'react';
import {Grid, Typography, Divider} from '@material-ui/core';

const RecordValidationDetails = () => {
  return (
    <>
      <div className="record-validation-header">
        <h1 id="record-validation-header-title" className="record-validation-header__title">Record Validation Details</h1>
      </div>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} md={4} lg={3} xl={2}>
          <Typography align="left" className="title">
            Coverage Termination
          </Typography>
          <Divider className="divider" />
          <Typography align="left" className="value">
            2
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={3} xl={2}>
          <Typography align="left" className="title">
            Coverage Election
          </Typography>
          <Divider className="divider" />
          <Typography align="left" className="value">
            1
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={3} xl={2}>
          <Typography align="left" className="title">
            Coverage Change
          </Typography>
          <Divider className="divider" />
          <Typography align="left" className="value">
            1
          </Typography>
        </Grid>
      </Grid>
    </>
  );
};

export default RecordValidationDetails;
